import { render } from "./NotificationBar.vue?vue&type=template&id=31ab5a1a&scoped=true"
import script from "./NotificationBar.vue?vue&type=script&lang=js"
export * from "./NotificationBar.vue?vue&type=script&lang=js"

import "./NotificationBar.vue?vue&type=style&index=0&id=31ab5a1a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-31ab5a1a"

export default script